import { CheckApiKey, CheckPolicy, Resource } from '../../framework/permission-util'
import { RT } from '../permissions'
import Executive from '../../framework/rmi-util'
import { register } from '../../framework/rmi-server-util'
import { cleanupAiThreads, translateContent, guessCategories, guessCustomerSegmentTags, generateWithFreddy, refreshVectorStore } from './AiTechnical'
import type { TranslationRequest, TranslationResponse } from './ai.entities'
import { CleanupResult, Features } from '../contract/util/types'
import { cmClient } from '../../legacy/contentmanager-util'
import { clientHasFeature } from '../contract/util/client'
import { FreddyRequestType } from './util/freddy-api-client'

class I18nString {
	de: string
	[ locale: string ]: string
}

export class GuessCategoryRequest {
	title: I18nString
	shortDescription: I18nString
	longDescription: I18nString
	address: string
}

export class GuessCustomerSegmentTagsRequest {
	title: I18nString
	shortDescription: I18nString
	longDescription: I18nString
	address: string
}

export default class AiExecutive extends Executive {

	initServer() {
	}

	@CheckPolicy()
	async guessCategories(@Resource(RT.CLIENT) clientId: string, request: GuessCategoryRequest): Promise<string[]> {
		return await guessCategories(clientId, request)
	}

	@CheckPolicy()
	async guessCustomerSegmentTags(@Resource(RT.CLIENT) clientId: string, request: GuessCustomerSegmentTagsRequest): Promise<Object> {
		return await guessCustomerSegmentTags(clientId, request)
	}

	@CheckPolicy()
	async translate(@Resource(RT.CLIENT) clientId: string, request: TranslationRequest): Promise<TranslationResponse> {
		return await translateContent(clientId, request)
	}

	// Only for testing from Postman - the cronjob will directly call the technical
	@CheckApiKey()
	async cleanupAiThreads(@Resource(RT.CLIENT) clientId: string): Promise<CleanupResult> {
		return await cleanupAiThreads()
	}

	@CheckPolicy()
	async generateWithFreddy(@Resource(RT.CLIENT) clientId: string, @Resource(RT.PROVIDER) spId: string, request: any, type: FreddyRequestType): Promise<any> {
		return await generateWithFreddy(clientId, request, type)
	}

	@CheckApiKey()
	async refreshVectorStore(@Resource(RT.CLIENT) clientId: string, organizationId: string, assistantId: string): Promise<void> {
		await refreshVectorStore(clientId, organizationId, assistantId)
	}

	@CheckApiKey()
	async refreshVectorStores(): Promise<void> {
		const clients = await cmClient.getEntries({
			content_type: 'client',
			include: 0,
			select: 'title,features,organizationId,freddyAssistantId',
		})
				
		const clientsToRefresh = []
		for (const client of clients) {
			if (clientHasFeature(client, Features.ClientFeatures.AI_PRODUCT_CATEGORIES) || clientHasFeature(client, Features.ClientFeatures.AI_CUSTOMER_SEGMENTS)) {
				const organizationId = client.fields?.organizationId?.de || '3'
				const assistantId = client.fields?.freddyAssistantId?.de
				if (!assistantId) {
					throw new Error(`Assistant ID not found for client ${client.sys.id}`)
				}
				clientsToRefresh.push({ clientId: client.sys.id, organizationId, assistantId })
			}
		}
		await Promise.all(clientsToRefresh.map(client => refreshVectorStore(client.clientId, client.organizationId, client.assistantId)))
	}
}

register(AiExecutive)